import { render, staticRenderFns } from "./MemberDocuments.vue?vue&type=template&id=3a86f95e&scoped=true"
import script from "./MemberDocuments.vue?vue&type=script&lang=js"
export * from "./MemberDocuments.vue?vue&type=script&lang=js"
import style0 from "./MemberDocuments.vue?vue&type=style&index=0&id=3a86f95e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a86f95e",
  null
  
)

export default component.exports